const routesNames = {
  login: "/login",
  registration: "/registration",
  createProfile: "/create-profile",
  createProfileForGoogle: "/create-profile/:email",
  home: "/home",

  // home
  homePersonification: "/Personalisation",
  chat: "/chat",
  // search: "/search",
  notifications: "/notifications",

  profile: "/profile",
  othersProfile: "/profile/others-profile/:othersUserId",
  editProfile: "/profile/edit-profile",
  favourite: "/profile/favourite",

  viewpost: "/home/view-post/:id/:userId",
  infoGraphics: "/home/info-graphics/:screen",

  // create project
  upload: "/upload",
  createPost: "/upload/create-post",
  createProject: "/upload/create-project",
  addPostDetails: "/upload/add-post-details",
  termsAndConditions: "/upload/terms-and-conditions",
  artistDetails: "/upload/artist-details",
  previewProject: "/upload/preview-project",
  previewPost: "/upload/preview",
  postReorder: "/upload/reorder",

  // dashboard
  dashboard: "/dashboard",
  myProjects: "/dashboard/my-projects",
  myEvents: "/dashboard/my-events",
  myCollaborations: "/dashboard/my-collaborations",
  myCalender: "/dashboard/my-calender",
  mediaGallery: "/dashboard/media-gallery",
  scribbleBoard: "/dashboard/scribble-board",
  projectDetails: "/dashboard/project-details/:id",
  askToCollaborate: "/dashboard/ask-to-collaborate",
  viewAllArtists: "/dashboard/view-all-artists",
  viewAllCollaborator: "/dashboard/view-all-collaborator",
  inviteMoreCollaborator: "/dashboard/invite-more-collaborator",
  previewTask: "/dashboard/preview-task",
  createTask: "/dashboard/create-task",
  requestNegotiation: "/dashboard/request-negotiation",
  addArtists: "/dashboard/add-artists",
  endProject: "/dashboard/end-project",

  blogs: "/blogs",
  viewBlogs: "/view-blog",
  events: "/home/events",
  viewEvent: "/home/view-event",
  explore: "/explore",
  projects: "/projects",
  exploreQuickApply: "/explore-quick-apply",

  // if user exist while regestering
  userExist: "/user-exist",

  //Help and support
  profileSettings: "/profile/settings",
  helpAndSupport: "/profile/help-and-support",
  helpCentre: "/profile/help-centre",
  reportProblem: "/profile/profile/report-problem",
  sendFeedback: "/profile/send-feedback",
  supportRequests: "/profile/support-requests",
  rateSekeron: "/profile/rate-sekeron",
  legal: "/profile/legal",
  faqSettings: "/profile/faq-settings",
  profileSecurity: "/profile/profile-security",
  loginActivity: "/profile/login-activity",
  loginCredentials: "/profile/login-credentials",
  notofiactionsSettings: "/profile/notifications-settings",
  editPost: "/profile/edit-post",
  viewAllProjects: "/profile/view-all-projects",
  blockedUsers: "/profile/block-users",

  //policies
  policies: "/policies",
  termsAndConditionPolicy: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  accountDeletionPolicy: "/data-deletion-policy",
  collaborationPolicy: "/collaboration-policy",
  communityGuidelines: "/community-guidelines",
  collaborationAgreement: "/collaboration-agreement",
  refundPolicy: "/refund-policy",

  //
  comingSoon: "/coming-soon",

  //events
  eventDetails: "/event-details/:id"
};

export default routesNames;
